import request from '@/utils/request'
// 平台优惠券列表
export function platformCouponList(params) {
  return request({
    url: '/coupon/list',
    method: 'get',
    params: params
  })
}
// 供应商优惠券列表
export function supplierCouponList(params) {
  return request({
    url: '/coupon/mcht/list',
    method: 'get',
    params
  })
}
// 添加优惠券
export function createCoupon(data) {
  return request({
    url: '/coupon/create',
    method: 'post',
    data: data
  })
}
// 获取优惠券详情
export function couponDetail(id) {
  return request({
    url: '/coupon/' + id,
    method: 'get',
  })
}
// 修改优惠券
export function updateCoupon(data) {
  return request({
    url: '/coupon',
    method: 'put',
    data: data
  })
}
// 删除优惠券
export function deleteCoupon(id) {
  return request({
    url: '/coupon/delete/' + id,
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/coupon.js